"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadBill = downloadBill;
exports.downloadDo = downloadDo;
exports.downloadVoyageCertificate = downloadVoyageCertificate;
exports.searchHistory = searchHistory;
var _request = _interopRequireDefault(require("@/utils/request"));
// 换单预约历史-查询上海
function searchHistory(data) {
  return (0, _request.default)({
    url: "/ebusiness/docEdoAccredit/searchHistory",
    method: 'post',
    data: data
  });
}

// 换单预约历史-DO打印(上海)
function downloadDo(bookingHeadId) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/docEdoAccredit/downloadDo/".concat(bookingHeadId),
    method: 'post'
  });
}
//换单预约历史-账单打印(上海)
function downloadBill(blNo) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/docEdoAccredit/downloadBill/".concat(blNo),
    method: 'post'
  });
}
//换单预约历史-航次证明(上海)
function downloadVoyageCertificate(blNo) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/docEdoAccredit/downloadVoyageCertificate/".concat(blNo),
    method: 'post'
  });
}